module.exports = __webpack_public_path__ + "static/media/YF97_2.4a7a78d3.jpg";